// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"137":"6a1a232f","194":"71806574"}[chunkId] + ".css";
};